module.exports = __webpack_public_path__ + "static/media/service-scenario-bg4.c07b2cf4.png";